(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire278c"];
var parcelRegister = parcelRequire.register;
parcelRegister("gI3x7", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2a37f057a712caf$export$2e2bcd8739ae039);
const $c2a37f057a712caf$var$initSlideOutPanels = ()=>{
    // When a link is clicked with an anchor, see if a div with that ID exists, and add the is-active class
    $('a[href*="#"]').click(function(e) {
        const id = this.hash.slice(1);
        var target = $(`#${id}.slide-out-panel`);
        target = target.length ? target : $(".slide-out-panel[name=" + this.hash.slice(1) + "]");
        // Prevent scrolling and show panel
        if (target.length) {
            e.preventDefault();
            $(target).addClass("is-active");
        }
    });
    // If the user clicks outside it, close it
    $(".slide-out-panel").click(function(e) {
        var clickedElement = e.target;
        // Only close it if the clicked element has this class, ignore children
        if (clickedElement.className === "slide-out-panel is-active") $(this).removeClass("is-active");
    });
    // Focus search bar when open
    $(".js-site-search").click(function() {
        window.setTimeout(function() {
            $(".slide-out-search-box").focus();
        }, 600);
    });
};
var $c2a37f057a712caf$export$2e2bcd8739ae039 = $c2a37f057a712caf$var$initSlideOutPanels;

});

})();
//# sourceMappingURL=slide-out-panels.0bb4d75d.js.map
